// Vendor
import { createSelector } from '@ngrx/store';
// Selectors
import { getChartState } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart-base.selectors';
const getEndDate = createSelector(getChartState, (chartState) => chartState.endDate);
const getChartData = createSelector(getChartState, (chartState) => chartState.chartData);
const getChartDataEndDate = createSelector(getChartData, (chartData) => chartData.end_date);
export const getChartEndDate = createSelector(getEndDate, getChartDataEndDate, (endDate, chartDataEndDate) => {
    const dateToUse = endDate || chartDataEndDate;
    return dateToUse ? new Date(dateToUse) : null;
});
